import Clarity from '@microsoft/clarity';
import { STORAGE_KEYS } from 'const';

const env = process.env.REACT_APP_ENVIRONMENT || 'local';
const isAnalyticsEnabled = env !== 'local';

const init = () => {
  if (!isAnalyticsEnabled) return;

  try {
    Clarity.init(process.env.REACT_APP_CLARITY_PROJECT_ID);
    identify();
  } catch (e) {
    console.error('Clarity init failed', e);
  }
};

const event = (eventName) => {
  if (!isAnalyticsEnabled) return;
  try {
    Clarity.event(eventName);
  } catch (e) {
    console.error('Clarity event failed', e);
  }
};

const identify = (user = {}) => {
  if (!isAnalyticsEnabled) return;
  try {
    const sessionid = localStorage.getItem(STORAGE_KEYS.SESSION_ID);
    Clarity.identify(user.id || null, sessionid, null, user.username || null);
  } catch (e) {
    console.error('Clarity identify failed', e);
  }
};

const setTag = (key, value) => {
  if (!isAnalyticsEnabled) return;
  try {
    Clarity.setTag(key, value);
  } catch (e) {
    console.error('Clarity setTag failed', e);
  }
};

const setShopInAnalytics = (shop) => {
  if (!isAnalyticsEnabled) return;
  try {
    const subscription_str = `${shop.subscription.name} (${shop.subscription.id})`;
    setTag('shop-id', shop.id);
    setTag('shop-name', shop.shop_name);
    setTag('dealer-id', shop.dealer_id);
    setTag('subscription', subscription_str);
    setTag('tax-region', shop.tax_region);
    setTag('plan-type', shop.subscription.type);
    setTag('session-id', localStorage.getItem(STORAGE_KEYS.SESSION_ID));
  } catch (error) {
    console.error('Error settings tags to analytics', error);
  }
};

const AnalyticsHelper = {
  init,
  event,
  identify,
  setTag,
  setShopInAnalytics,
};

export default AnalyticsHelper;
